import React from "react";
import "./index.css";
import InfoSection from "datalign-module-template/models/info-sections";
import MainInfoSection from "./main-info-section";
import ThreeColumnsSection from "./three-columns";
import TwoColumnsSection from "./two-columns";
import OneColumnsSection from "./one-columns";

const InfoSections = ({ infoSections }: { infoSections?: InfoSection[] }) => {
  return (
    <div className="grid" style={{ width: "100%" }}>
      {infoSections &&
        infoSections.length > 0 &&
        infoSections.map((infoSection) =>
          infoSection.variant === "main" ? (
            <MainInfoSection
              key={`info-section-${infoSection.guid}`}
              infoSection={infoSection}
            />
          ) : infoSection.variant === "1-column" ? (
            <OneColumnsSection
              key={`info-section-${infoSection.guid}`}
              infoSection={infoSection}
            />
          ) : infoSection.variant === "2-column" ? (
            <TwoColumnsSection
              key={`info-section-${infoSection.guid}`}
              infoSection={infoSection}
            />
          ) : infoSection.variant === "3-column" ? (
            <ThreeColumnsSection
              key={`info-section-${infoSection.guid}`}
              infoSection={infoSection}
            />
          ) : (
            <></>
          ),
        )}
    </div>
  );
};

export default InfoSections;
